import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import BundleSection from './components/BundleSection';
import ReviewsSection from './components/ReviewsSection';
import GallerySection from './components/GallerySection';
import ContactCallToAction from './components/ContactCallToAction';
import FullGallery from './components/FullGallery';
import Commercial from './pages/Commercial';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import ContactForm from './pages/ContactForm';
import Quote from './pages/Quote';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Footer from './components/Footer';
import StickyHelpButton from './components/StickyHelpButton';
import NewsletterPopup from './components/NewsletterPopup';
import ScrollToTop from './components/ScrollToTop';
import SEO from './components/SEO';

// Import individual service pages
import WindowWashing from './pages/services/WindowWashing';
import PressureWashing from './pages/services/PressureWashing';
import RoofCleaning from './pages/services/RoofCleaning';
import GutterCleaning from './pages/services/GutterCleaning';
import SolarPanelCleaning from './pages/services/SolarPanelCleaning';
import ExteriorCleaning from './pages/services/ExteriorCleaning';
import DeckPatioCleaning from './pages/services/DeckPatioCleaning';

function HomePage() {
  return (
    <>
      <SEO
        title="Pressure Washing Austin TX | Window Cleaning, Solar Panel & Roof Cleaning | Elev8 Solutions"
        description="Premier pressure washing, window cleaning, and exterior cleaning services in Austin, Texas. Serving Westlake, Lakeway, Round Rock. Licensed & insured. Get your free quote today!"
        keywords="pressure washing Austin, window washing Austin, solar panel cleaning Austin Texas, roof cleaning Austin, exterior cleaning Austin"
        canonicalUrl="https://elev8texas.com/"
      />
      <HeroSection />
      <ServicesSection />
      <BundleSection />
      <ReviewsSection />
      <GallerySection />
      <ContactCallToAction />
    </>
  );
}

function App() {
  const [showNewsletterPopup, setShowNewsletterPopup] = React.useState(false);
  const [hasShownPopup, setHasShownPopup] = React.useState(false);

  React.useEffect(() => {
    // Check if popup has been shown before (localStorage)
    const hasSeenNewsletter = localStorage.getItem('elev8-newsletter-shown');
    
    if (!hasSeenNewsletter && !hasShownPopup) {
      const timer = setTimeout(() => {
        setShowNewsletterPopup(true);
        setHasShownPopup(true);
        localStorage.setItem('elev8-newsletter-shown', 'true');
      }, 30000); // 30 seconds

      return () => clearTimeout(timer);
    }
  }, [hasShownPopup]);

  const handleCloseNewsletter = () => {
    setShowNewsletterPopup(false);
  };

  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-background-primary">
        <Routes>
          <Route path="/" element={
            <>
              <Navigation />
              <HomePage />
              <Footer />
              <StickyHelpButton />
            </>
          } />
          <Route path="/gallery" element={
            <>
              <SEO
                title="Our Work Gallery - Pressure Washing & Cleaning Results in Austin TX"
                description="See before-and-after results from our pressure washing, window cleaning, roof cleaning, and exterior cleaning projects across the Greater Austin area."
                canonicalUrl="https://elev8texas.com/gallery"
              />
              <Navigation />
              <FullGallery />
              <Footer />
              <StickyHelpButton />
            </>
          } />
          <Route path="/commercial" element={<Commercial />} />
          <Route path="/services" element={<Services />} />
          
          {/* Individual Service Pages */}
          <Route path="/services/window-washing" element={<WindowWashing />} />
          <Route path="/services/pressure-washing" element={<PressureWashing />} />
          <Route path="/services/roof-cleaning" element={<RoofCleaning />} />
          <Route path="/services/gutter-cleaning" element={<GutterCleaning />} />
          <Route path="/services/solar-panel-cleaning" element={<SolarPanelCleaning />} />
          <Route path="/services/exterior-cleaning" element={<ExteriorCleaning />} />
          <Route path="/services/deck-patio-cleaning" element={<DeckPatioCleaning />} />
          
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/help" element={<ContactForm />} />
          <Route path="/quote" element={<Quote />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
        </Routes>
        
        {/* Newsletter Popup */}
        <NewsletterPopup 
          isVisible={showNewsletterPopup} 
          onClose={handleCloseNewsletter} 
        />
      </div>
    </Router>
  );
}

export default App;
